<template>
  <div class="details-wrapper">
    <div class="details-body">
      <div class="content-panel-wrapper">
        <div v-scroll-spy data-scroll-spy-id="main-tab" class="content-panel">
          <ClientContactDetailsForm :client-contact="newClientContact" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AppActions } from '@/app/app.keys';
import ClientContactDetailsForm from '../client-contact-details/components/ClientContactDetailsForm';
import { NewClientContactGetters } from './new-client-contact.keys';

export default {
  name: 'NewClientContact',
  components: { ClientContactDetailsForm },

  computed: {
    newClientContact() {
      const newClientContact = this.$store.getters[NewClientContactGetters.NewClientContact];
      newClientContact.clientName = this.$route.query.name;
      newClientContact.clientId = this.$route.query.id;
      return newClientContact;
    }
  },

  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('clientContact.labels.newClientContact'));
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.details-wrapper {
  display: flex;
  flex-direction: column;

  background-color: $background-level-2;

  .details-body {
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    border-right: 4px solid rgba(255, 255, 255, 0);
    &.modified {
      border-right: 4px solid $modified-form;
    }

    .content-panel-wrapper {
      flex: 0 85%;
      .content-panel {
        display: block;
        background-color: $white;
        padding: 60px;
      }
    }
  }
}
</style>
